<template>
  <div id="Hardware">
    <div class="banner">
      <img src="/static/images/features/m_hd_bg.png" alt="">
      <div class="bannerText">Lettuce Software</div>
    </div>
    <div class="content">
        <div class="con">
          <div class="box"  v-for="item in list" :key="(item.title,item.titleSub,item.con)">
            <div>
              <img :src="item.img" alt="">
            </div>
            <div class="detail">
              <div class="tit">{{$t(item.title)}}</div>
              <div class="titSub">{{$t(item.titleSub)}}</div>
              <div class="titCon">{{$t(item.con)}}</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        list:[
        {
          img:'/static/images/home/web/m_con3_1.png',
          title:'home.con2.table2.title1',
          titleSub:'home.con2.table2.titleSub1',
          con:'home.con2.table2.con1',
        },
       {
          img:'/static/images/home/web/m_con3_2.png',
          title:'home.con2.table2.title2',
          titleSub:'home.con2.table2.titleSub2',
          con:'home.con2.table2.con2',
        },
       {
          img:'/static/images/home/web/m_con3_3.png',
          title:'home.con2.table2.title3',
          titleSub:'home.con2.table2.titleSub3',
          con:'home.con2.table2.con3',
        },
       {
          img:'/static/images/home/web/m_con3_4.png',
          title:'home.con2.table2.title4',
          titleSub:'home.con2.table2.titleSub4',
          con:'home.con2.table2.con4',
        },
      ],
      selectId:0
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Hardware{
  margin-top: 50px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 10%;
      left: 0;
      right:0;
      margin: auto;
      color: #333;
      font-size: 34px;
      font-weight: bold;
      text-align: center;
    }
  }
  .content{
    padding: 2rem 0;
    .con{
      width: 80%;
      margin: 0 auto;
      .box{
        margin-bottom: 20px;
        img{
          width: 100%;
        }
        .detail{
          color: #333;
          padding: 1rem 0 3rem 0;
          .tit{
            font-size:2rem;
            font-weight: bold;
          }
          .titSub{
            font-size:1.6rem;
            color: #999;
            padding: .6rem 0;
            font-weight: bold;
          }
          .titCon{
            font-size:1.2rem;
            color: #666;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Features/Hardware.vue